import { Button, ButtonProps } from '@chakra-ui/react'
import { FC } from 'react'

const BuyNowButton: FC<ButtonProps> = ({ children, ...rest }) => {
  return (
    <Button
      bg="dandelion"
      _hover={{
        bg: 'dandelion'
      }}
      color="phthalo"
      px={8}
      py={8}
      fontWeight={800}
      fontSize="20px"
      sx={{ fontFeatureSettings: "'ss01' on, 'calt' off, 'liga' off" }}
      letterSpacing="-0.01em"
      lineHeight="24px"
      shadow="none"
      w="fit-content"
      {...rest}
    >
      {children}
    </Button>
  )
}

export default BuyNowButton
